export default __webpack_public_path__ + "img/d8225027e205bb22f88b55fe8b2acee8.png";